import React, { useMemo } from 'react';

import { Modal } from 'components';

import { modalTypes } from '../../index';
import ProductRelease from '../ProductRelease';
import ProductSupply from '../ProductSupply';
import WarehouseAddProduct from '../WarehouseAddProduct';

const ProductModal = ({ isOpen, setIsOpen, modalType, refreshData }) => {
  const modalContent = useMemo(() => {
    switch (modalType) {
      case modalTypes.addNew:
        return {
          title: 'Dodaj produkt',
          content: (
            <WarehouseAddProduct
              refreshData={refreshData}
              closeModal={() => setIsOpen(false)}
            />
          )
        };
      case modalTypes.increase:
        return {
          title: 'Dostawa do magazynu',
          content: (
            <ProductSupply
              closeModal={() => setIsOpen(false)}
              refreshData={refreshData}
            />
          )
        };
      case 'decrease':
        return {
          title: 'Wydanie z magazynu',
          content: (
            <ProductRelease
              closeModal={() => setIsOpen(false)}
              refreshData={refreshData}
            />
          )
        };
      default:
        return { title: '', content: null };
    }
  }, [modalType]);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      visible={isOpen}
      onClose={handleCloseModal}
      title={modalContent.title}
    >
      {modalContent.content}
    </Modal>
  );
};

export default ProductModal;
